import { ApiResponse } from "api/api.d";
import { api } from "api/api";
import {
  CheckScopeConflictRequest,
  GetCreditCardsRequest,
  GetCreditCardDetailRequest,
  GetCreditCardStatementRequest,
  GetCreditCardDebtInfoRequest,
  InitCreditCardPaymentRequest,
  CreditCardPaymentRequest,
  GetDebitCardDetailRequest,
  ExportDebitCardTransactionsRequest,
  GetDebitCardOverviewRequest,
  GetDebitCardsRequest,
  GetDebitCardTransactionsRequest,
  GetSensitiveDebitCardInfoRequest,
  InitLinkToBizRequest,
  LinkToBizCreditCardRequest,
  InitOnlinePaymentCreditCardRequest,
  OnlinePaymentCreditCardRequest,
  InitLockDebitCardRequest,
  InitUnlockDebitCardRequest,
  InitUpdateLimitCardRequest,
  LinkToBizRequest,
  LockDebitCardRequest,
  UnlockDebitCardRequest,
  UpdateLimitCardRequest,
} from "@/dto/card/request/CardRequest";
import {
  CheckScopeConflictResponse,
  GetAccountCardListResponse,
  GetCreditCardsResponse,
  GetCreditCardDetailResponse,
  GetCreditCardStatementResponse,
  GetCreditCardDebtInfoResponse,
  InitCreditCardPaymentResponse,
  GetDebitCardDetailResponse,
  GetDebitCardLimitOptionsResponse,
  ExportDebitCardTransactionsResponse,
  GetDebitCardOverviewResponse,
  GetDebitCardsResponse,
  GetDebitCardTransactionsResponse,
  GetSensitiveDebitCardInfoResponse,
  InitLinkToBizResponse,
  InitLockDebitCardResponse,
  InitUnlockDebitCardResponse,
  InitUpdateLimitCardResponse,
  LinkToBizResponse,
  LockDebitCardResponse,
  UnlockDebitCardResponse,
  UpdateLimitCardResponse,
} from "@/dto/card/response/CardResponse";

const BASE_URL = "/customer-service/rest/app/request";

export const cardAPI = api.injectEndpoints({
  endpoints: (builder) => ({
    getDebitCards: builder.query<
      ApiResponse<GetDebitCardsResponse>,
      GetDebitCardsRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "getDebitCards",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    getCreditCards: builder.query<
      ApiResponse<GetCreditCardsResponse>,
      GetCreditCardsRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "getCreditCards",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    getDebitCardDetail: builder.query<
      ApiResponse<GetDebitCardDetailResponse>,
      GetDebitCardDetailRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "getDebitCardDetail",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    getCreditCardDetail: builder.query<
      ApiResponse<GetCreditCardDetailResponse>,
      GetCreditCardDetailRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "getCreditCardDetail",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    // Thẻ tín dụng dùng chung shape request/response với thẻ ghi nợ, khác functionName.
    initLockCreditCard: builder.mutation<
      ApiResponse<InitLockDebitCardResponse>,
      InitLockDebitCardRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "initLockCreditCard",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    lockCreditCard: builder.mutation<
      ApiResponse<LockDebitCardResponse>,
      LockDebitCardRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "lockCreditCard",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    initUnlockCreditCard: builder.mutation<
      ApiResponse<InitUnlockDebitCardResponse>,
      InitUnlockDebitCardRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "initUnlockCreditCard",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    unlockCreditCard: builder.mutation<
      ApiResponse<UnlockDebitCardResponse>,
      UnlockDebitCardRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "unlockCreditCard",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    initLockDebitCard: builder.mutation<
      ApiResponse<InitLockDebitCardResponse>,
      InitLockDebitCardRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "initLockDebitCard",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    lockDebitCard: builder.mutation<
      ApiResponse<LockDebitCardResponse>,
      LockDebitCardRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "lockDebitCard",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    getAccountCardList: builder.query<
      ApiResponse<GetAccountCardListResponse>,
      void
    >({
      query: () => ({
        url: BASE_URL,
        method: "POST",
        functionName: "getAccountCardList",
        categoryCode: "CORP_TRANS_TRANSFER_TO_ACCOUNT",
      }),
    }),
    initUnlockDebitCard: builder.mutation<
      ApiResponse<InitUnlockDebitCardResponse>,
      InitUnlockDebitCardRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "initUnlockDebitCard",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    unlockDebitCard: builder.mutation<
      ApiResponse<UnlockDebitCardResponse>,
      UnlockDebitCardRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "unlockDebitCard",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    initUpdateLimitCard: builder.mutation<
      ApiResponse<InitUpdateLimitCardResponse>,
      InitUpdateLimitCardRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "initUpdateLimitCard",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    updateLimitCard: builder.mutation<
      ApiResponse<UpdateLimitCardResponse>,
      UpdateLimitCardRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "updateLimitCard",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    checkScopeConflict: builder.mutation<
      ApiResponse<CheckScopeConflictResponse>,
      CheckScopeConflictRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "checkScopeConflict",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    initGetSensitiveDebitCardInfo: builder.mutation<
      ApiResponse<any>,
      { cardId: number }
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "initGetSensitiveDebitCardInfo",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    getSensitiveDebitCardInfo: builder.mutation<
      ApiResponse<GetSensitiveDebitCardInfoResponse>,
      GetSensitiveDebitCardInfoRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "getSensitiveDebitCardInfo",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    // JVC-3543: xem chi tiết thẻ TÍN DỤNG (số thẻ/ngày hết hạn/CVV) — cùng shape với debit
    initGetSensitiveCreditCardInfo: builder.mutation<
      ApiResponse<any>,
      { cardId: number }
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "initGetSensitiveCreditCardInfo",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    getSensitiveCreditCardInfo: builder.mutation<
      ApiResponse<GetSensitiveDebitCardInfoResponse>,
      GetSensitiveDebitCardInfoRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "getSensitiveCreditCardInfo",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    initLinkToBiz: builder.mutation<
      ApiResponse<InitLinkToBizResponse>,
      InitLinkToBizRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "initLinkToBiz",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    linkToBiz: builder.mutation<
      ApiResponse<LinkToBizResponse>,
      LinkToBizRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "linkToBiz",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    // Liên kết Javis Biz cho thẻ tín dụng (init dùng chung shape với debit).
    initLinkToBizCreditCard: builder.mutation<
      ApiResponse<InitLinkToBizResponse>,
      InitLinkToBizRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "initLinkToBizCreditCard",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    linkToBizCreditCard: builder.mutation<
      ApiResponse<LinkToBizResponse>,
      LinkToBizCreditCardRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "linkToBizCreditCard",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    // Đăng ký/huỷ thanh toán trực tuyến thẻ tín dụng (init + confirm OTP).
    initOnlinePaymentCreditCard: builder.mutation<
      ApiResponse<InitLinkToBizResponse>,
      InitOnlinePaymentCreditCardRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "initOnlinePaymentCreditCard",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    onlinePaymentCreditCard: builder.mutation<
      ApiResponse<LinkToBizResponse>,
      OnlinePaymentCreditCardRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "onlinePaymentCreditCard",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    getDebitCardLimitOptions: builder.query<
      ApiResponse<GetDebitCardLimitOptionsResponse>,
      void
    >({
      query: () => ({
        url: BASE_URL,
        method: "POST",
        functionName: "getDebitCardLimitOptions",
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    getDebitCardOverview: builder.query<
      ApiResponse<GetDebitCardOverviewResponse>,
      GetDebitCardOverviewRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "getDebitCardOverview",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    getDebitCardTransactions: builder.query<
      ApiResponse<GetDebitCardTransactionsResponse>,
      GetDebitCardTransactionsRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "getDebitCardTransactions",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    getCreditCardTransactions: builder.query<
      ApiResponse<GetDebitCardTransactionsResponse>,
      GetDebitCardTransactionsRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "getCreditCardTransactions",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    getCreditCardStatement: builder.query<
      ApiResponse<GetCreditCardStatementResponse>,
      GetCreditCardStatementRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "getCreditCardStatement",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    getCreditCardDebtInfo: builder.query<
      ApiResponse<GetCreditCardDebtInfoResponse>,
      GetCreditCardDebtInfoRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "getCreditCardDebtInfo",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    initCreditCardPayment: builder.mutation<
      ApiResponse<InitCreditCardPaymentResponse>,
      InitCreditCardPaymentRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "initCreditCardPayment",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    creditCardPayment: builder.mutation<
      ApiResponse<LockDebitCardResponse>,
      CreditCardPaymentRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "creditCardPayment",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
    exportDebitCardTransactions: builder.mutation<
      ApiResponse<ExportDebitCardTransactionsResponse>,
      ExportDebitCardTransactionsRequest
    >({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "exportDebitCardTransactions",
        data,
        categoryCode: "CORP_TRANS_CARD",
      }),
    }),
  }),
});

export const {
  useGetDebitCardsQuery,
  useGetCreditCardsQuery,
  useGetDebitCardDetailQuery,
  useGetCreditCardDetailQuery,
  useLazyGetCreditCardDetailQuery,
  useInitLockCreditCardMutation,
  useLockCreditCardMutation,
  useInitUnlockCreditCardMutation,
  useUnlockCreditCardMutation,
  useInitLinkToBizCreditCardMutation,
  useLinkToBizCreditCardMutation,
  useInitOnlinePaymentCreditCardMutation,
  useOnlinePaymentCreditCardMutation,
  useInitLockDebitCardMutation,
  useLockDebitCardMutation,
  useGetAccountCardListQuery,
  useInitUnlockDebitCardMutation,
  useUnlockDebitCardMutation,
  useInitUpdateLimitCardMutation,
  useUpdateLimitCardMutation,
  useCheckScopeConflictMutation,
  useInitGetSensitiveDebitCardInfoMutation,
  useGetSensitiveDebitCardInfoMutation,
  useInitGetSensitiveCreditCardInfoMutation,
  useGetSensitiveCreditCardInfoMutation,
  useInitLinkToBizMutation,
  useLinkToBizMutation,
  useGetDebitCardLimitOptionsQuery,
  useGetDebitCardOverviewQuery,
  useGetDebitCardTransactionsQuery,
  useGetCreditCardTransactionsQuery,
  useGetCreditCardStatementQuery,
  useLazyGetCreditCardStatementQuery,
  useGetCreditCardDebtInfoQuery,
  useInitCreditCardPaymentMutation,
  useCreditCardPaymentMutation,
  useExportDebitCardTransactionsMutation,
} = cardAPI;
